import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./SignUp.css";
import { signupUser } from "../../redux/slice/authSlice";
import { useDispatch } from "react-redux";
import eye from "../../assets/eye.png";
import hide from "../../assets/hide.png";
import { toast } from "react-toastify";

const SignUp = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    contact: "",
    password: "",
    confirmPassword: "",
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    if (name === "password") validatePassword(value);
    if (name === "confirmPassword")
      validateConfirmPassword(value, formData.password);
  };

  const validatePassword = (password) => {
    const minLength = password.length >= 8;
    const hasUppercase = /[A-Z]/.test(password);
    const hasNumber = /\d/.test(password);
    const hasSpecialChar = /[@$!%*?_&#]/.test(password);

    if (!minLength)
      setPasswordError("*Password must be at least 8 characters long.");
    else if (!hasNumber)
      setPasswordError("*Password must contain at least one number.");
    else if (!hasUppercase)
      setPasswordError("*Password must have at least one uppercase letter.");
    else if (!hasSpecialChar)
      setPasswordError("*Password must have one special character.");
    else setPasswordError("");
  };

  const validateConfirmPassword = (confirmPassword, password) => {
    if (confirmPassword && confirmPassword !== password) {
      setConfirmPasswordError("Passwords do not match.");
    } else {
      setConfirmPasswordError("");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (passwordError || confirmPasswordError) {
      toast.error("Your password doesn't meet the requirements.");
      return;
    }

    const values = {
      first_name: formData.firstName,
      last_name: formData.lastName,
      email: formData.email,
      contact: formData.contact,
      password: formData.confirmPassword,
    };

    setLoading(true);
    const response = await dispatch(signupUser({ values }));
    setLoading(false);

    if (signupUser.fulfilled.match(response)) {
      toast.success("User created successfully!");
      navigate("/login");
    } else {
      toast.error(response.payload || "Error during Sign Up");
    }
  };

  return (
    <div className="signup-container">
      {loading && (
        <div className="loader-overlay">
          <div className="loader"></div>
        </div>
      )}

      <form className="signup-box" onSubmit={handleSubmit}>
        <h2>Sign Up</h2>

        <div className="form-group">
          <label>First Name</label>
          <input
            type="text"
            name="firstName"
            className="inpppp"
            value={formData.firstName}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Last Name</label>
          <input
            type="text"
            name="lastName"
            className="inpppp"
            value={formData.lastName}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Email</label>
          <input
            type="email"
            name="email"
            className="inpppp"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Contact</label>
          <input
            type="text"
            name="contact"
            className="inpppp"
            value={formData.contact}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Password</label>
          <div className="password-input-container">
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              className="inpppp"
              value={formData.password}
              onChange={handleChange}
              required
            />
            <img
              src={showPassword ? hide : eye}
              alt="toggle visibility"
              className="password-toggle-icon"
              onClick={() => setShowPassword(!showPassword)}
            />
          </div>
          {passwordError && <p className="password-error">{passwordError}</p>}
        </div>

        <div className="form-group">
          <label>Confirm Password</label>
          <div className="password-input-container">
            <input
              type={showConfirmPassword ? "text" : "password"}
              name="confirmPassword"
              className="inpppp"
              value={formData.confirmPassword}
              onChange={handleChange}
              required
            />
            <img
              src={showConfirmPassword ? hide : eye}
              alt="toggle visibility"
              className="password-toggle-icon"
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
            />
          </div>
          {confirmPasswordError && (
            <p className="password-error">{confirmPasswordError}</p>
          )}
        </div>

        <button type="submit" className="signup-btn">
          Sign Up
        </button>

        <div className="back-option">
          <span onClick={() => navigate("/login")}>Back to Login</span>
        </div>
      </form>
    </div>
  );
};

export default SignUp;
